/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Steep_Nice_Ray_DineInputs */

const fr_steep_nice_ray_dine = /** @type {(inputs: Steep_Nice_Ray_DineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tarif`)
};

/**

* @param {Steep_Nice_Ray_DineInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const steep_nice_ray_dine = /** @type {((inputs?: Steep_Nice_Ray_DineInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Steep_Nice_Ray_DineInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_steep_nice_ray_dine(inputs)
});